export default "__VITE_ASSET__4ae8bd93__"